import { SalesLead } from '~/models/SalesLead'
import { SalesLeadRepository } from './repository'
import { Itinerary2 } from '~/models/Itinerary'

export class SalesLeadService {
	static async createLead(salesLead: SalesLead): Promise<SalesLead> {
		return await SalesLeadRepository.createLead(salesLead)
	}

	static async getLeadByTripId(tripId: string): Promise<SalesLead> {
		return await SalesLeadRepository.getLeadByTripId(tripId)
	}

	static async createTrip(salesLeadId: string): Promise<Itinerary2> {
		return SalesLeadRepository.createTrip(salesLeadId)
	}
}
